// extracted by mini-css-extract-plugin
module.exports = {"button":"LinkButton_button__-V12U","primaryColor":"LinkButton_primaryColor__QsPw0","secondaryColor":"LinkButton_secondaryColor__18OW5"};